<template lang='pug'>
div(class='search-bar' :class='{ xs: $vuetify.breakpoint.name === "xs" }')
  div(v-click-from-outside='requestClose')
    v-text-field(
      flat
      solo-inverted
      hide-details
      prepend-inner-icon='search'
      label='Поиск'
      class='search-form'
      v-model='query'
      :loading='loading'
      autofocus
    )
    v-card(v-if='hasResults' class='search-results')
      v-list(two-line light dense)
        template(v-for='(items, group) in results')
          div(:key='group')
            v-subheader(v-if='items.length') {{ group }}
            template(v-for='(item, index) in items')
              v-list-tile(
                class='v-list-tile'
                @click='resultClick({ group, item })'
              )
                v-list-tile-content
                  v-list-tile-title
                    | {{ item.first_name }}
                    | {{ item.second_name }}
                    | {{ item.last_name }}
                  v-list-tile-sub-title
                    | {{ item.phone }}
                    | {{ item.email }}
              v-divider(v-if='items.length - 1 > index')
</template>

<script>
import http from '@/http'
import { debounce } from 'lodash'
import { map, some, mapKeys, invert } from 'lodash'

export default {
  data: () => ({
    loading: false,
    query: null,
    results: {},
    names: {
      clients: 'Клиенты',
      managers: 'Менеджеры',
      users: 'Пользователи'
    }
  }),

  methods: {
    flushResults() {
      this.results = {}
    },

    setSearchResults(results) {
      this.results = results
    },

    dropSearch() {
      this.query = null
      this.flushResults()
    },

    requestClose() {
      this.$emit('blur')
    },

    async search(search) {
      let { data } = await http.get('search', { params: { search } })
      this.results = mapKeys(data, (v, k) => this.names[k] || k)
    },

    resultClick({ group, item }) {
      let route = {}

      switch (this.groupNames[group]) {
        case 'clients':
          route = {
            name: 'Admin.Clients.Edit',
            params: { id: item.id }
          }
          break

        case 'managers':
          route = {
            name: 'Admin.Managers.Edit',
            params: { id: item.id }
          }
          break

        case 'users':
          route = {
            name: 'Admin.Users.Edit',
            params: { id: item.id }
          }
          break
      }

      this.$router.push(route)
      this.requestClose()
    },

    trySearch: debounce(async function() {
      if (this.query && this.query.length >= 3) {
        this.loading = true

        await this.search(this.query)

        this.loading = false
      } else {
        this.flushResults()
      }
    }, 250)
  },

  computed: {
    hasResults() {
      return some(map(this.results, v => v.length))
    },

    groupNames() {
      return invert(this.names)
    }
  },

  watch: {
    query(val) {
      this.trySearch(val)
    }
  }
}
</script>

<style lang='scss' scoped>
.search-results {
  left: 0;
  top: 46px;
  width: 100%;
  position: absolute;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  max-height: 400px;
  overflow: auto;
}
.search-bar {
  width: 30%;
  position: relative;
  &.xs {
    width: 100%;
  }
}
.search-form {
  z-index: 2;
  position: relative;
}
.v-subheader {
  color: rgba(0, 0, 0, 0.54);
}
.v-divider {
  border-color: rgba(0, 0, 0, 0.12);
}
.v-list-tile:hover {
  background: rgba(0, 0, 0, 0.04);
}
</style>
